import Select from 'react-select';
import { SelectLoadingMessage } from '../UI/loading';
import React, { useState, useEffect } from 'react';
import { useAoneStore } from '../../store/AoneStore';

const SearchInput = ({
  id,
  options,
  name,
  label,
  value,
  isDisabled,
  isLoading,
  isMulti,
  isClearable,
  isRtl,
  isSearchable,
  getOptionLabel,
  getOptionValue,
  customStyles,
  handleChange,
  handleBlur,
  placeholder,
  onMenuOpen,
  onMenuClose,
  menuIsOpen,
  tabIndex,
  maxMenuHeight,
  applySelectedStyles,
  classNameSelect,
  parentCustomStyles = null,
  menuPortalTarget,
}) => {
  // Multi-selects report "nothing selected" as [], which is truthy.
  const hasValue = (v) => (Array.isArray(v) ? v.length > 0 : !!v);
  // Internal state to track if an option is selected
  const [isSelected, setIsSelected] = useState(hasValue(value));

  useEffect(() => {
    // Update selected state if value changes
    setIsSelected(hasValue(value));
  }, [value]);

  const combinedStyles = {
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
      ...(customStyles && customStyles.menuPortal),
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: '35px',
      fontSize: '12px',
      ...(applySelectedStyles && isSelected
        ? {
            borderColor: '#ec171c', // Persistent red border if selected
            boxShadow: '0 0 0 1px #ec171c',
            '&:hover': {
              borderColor: '#ec171c',
            },
          }
        : {}),
      ...(customStyles && customStyles.control),
    }),
    option: (provided, state) => ({
      ...provided,
      ...(customStyles && customStyles.option
        ? customStyles.option(provided, state)
        : {}),
    }),
  };

  return (
    <div style={parentCustomStyles}>
      <Select
        styles={combinedStyles}
        placeholder={placeholder}
        label={label}
        id={id}
        className={'basic-single' + ' ' + classNameSelect}
        classNamePrefix="select"
        value={value}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isLoading={isLoading}
        components={{ LoadingMessage: SelectLoadingMessage }}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        name={name}
        options={options}
        onChange={(selectedOption) => {
          setIsSelected(hasValue(selectedOption)); // Set border state based on selection
          handleChange(selectedOption);
        }}
        onBlur={handleBlur}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        menuIsOpen={menuIsOpen}
        maxMenuHeight={maxMenuHeight}
        menuShouldScrollIntoView={false}
        menuPlacement="bottom"
        menuPosition="fixed"
        menuPortalTarget={menuPortalTarget}
        tabIndex={tabIndex}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: '#fff2f2',
            primary: '#ec171c',
            primary50: '#FCAEAE',
            neutral20: '#7a869a',
          },
        })}
      />
    </div>
  );
};

export default SearchInput;
